"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var defaultRegionHrefs = {
  AT: 'https://www.digiexpert.at',
  BG: 'https://www.digiexpert.bg',
  CZ: 'https://www.digital24.cz',
  DE: 'https://www.digiexpert.de',
  DK: 'https://www.digiexpert.dk',
  FR: 'https://www.digiexpert.fr',
  GR: 'https://www.digiexpert.gr',
  HR: 'https://www.digiexpert.hr',
  HU: 'https://www.digiexpert.hu',
  IT: 'https://www.digiexpert.it',
  PL: 'https://www.digiexpert.pl',
  RO: 'https://www.digiexpert.ro',
  RS: 'https://www.digiexpert.rs',
  SI: 'https://www.digiexpert.si',
  SK: 'https://www.digital24.sk'
};
var _default = defaultRegionHrefs;
exports.default = _default;